import { Button } from "react-bootstrap";
import "@/styles/components/gitcha-not-available-modal.css";
import Modal from "react-bootstrap/Modal";
import { urlLinks } from "@/constants";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";


const GitchaNotAvailableModal = (props) => {

  const {
    show,
    onHide,
  } = props;

  const { isGitchaDefaultWebsite, mls } = useCurrentWebsite();
  const brand = isGitchaDefaultWebsite ? "Gitcha" : (mls || "").toUpperCase();

  const handleLearnMoreNavigation = () => {
    window.open(urlLinks.gitchaMLSIntegration, "_blank");
  };

  const handleContactUsNavigation = () => {
    window.open(urlLinks.contactUs, "_blank");
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        dialogClassName="modal-wrapper"
        backdrop="static"
      >
        <Modal.Body className="modal-body">

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          />

          <div className="content-container">
            <h3 className="content-title-text">
              {brand} isn't currently available in this location
            </h3>
            <p className="fs-6 content-description-text">{brand} and the Buyer Listing Service® launch market by market through MLS and association partnerships.</p>

            {isGitchaDefaultWebsite && (
              <div className="mb-4 mt-4">
                <p className="fs-6 ms-1 content-description-text"> • Participation by your MLS or association unlocks The Buyer Listing Service® & Gitcha</p>
                <p className="fs-6 ms-1 content-description-text"> • The BLS allows agent members to syndicate buyer demand to Gitcha for public visibility. </p>
                <p className="fs-6 ms-1 content-description-text"> • We’re actively expanding into new markets, so be on the lookout. </p>
              </div>
            )}

            <p className="fs-6 content-description-text"> If you’re a licensed agent, ask your MLS or association about launching the Buyer Listing Service® in your market. </p>
          </div>

          {isGitchaDefaultWebsite && (
            <div className="modal-footer mt-20 p-0 d-flex" style={{ gap: 15 }}>
              <Button variant="secondary" onClick={handleLearnMoreNavigation}>Learn More</Button>
              <Button variant="primary" onClick={handleContactUsNavigation}>Contact Us</Button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default GitchaNotAvailableModal;
